function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "SearchNavigationClick",
  transform: "translate(-457 -23.526)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_983",
  "data-name": "Group 983",
  transform: "translate(2861 -9468)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_117",
  className: "background",
  "data-name": "Ellipse 117",
  cx: 22,
  cy: 22,
  r: 22,
  transform: "translate(-2404 9491.526)",
  fill: "#f2f7fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "SearchbarCollapsed_M",
  transform: "translate(456.851 23.818)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_278",
  className: "search",
  "data-name": "Group 278",
  transform: "translate(10 10)",
  fill: "none",
  stroke: "#002d56",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M0 0l5.487 5.542",
  transform: "translate(18.273 18.578)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  cx: 10.5,
  cy: 10.5,
  r: 10.5,
  transform: "translate(.149 .182)",
  strokeMiterlimit: 10
}))));

function SvgSearchRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRound);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgdmlld0JveD0iMCAwIDQ0IDQ0Ij4KICA8ZyBpZD0iU2VhcmNoTmF2aWdhdGlvbkNsaWNrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDU3IC0yMy41MjYpIj4KICAgIDxnIGlkPSJHcm91cF85ODMiIGRhdGEtbmFtZT0iR3JvdXAgOTgzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyODYxIC05NDY4KSI+CiAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTE3IiBjbGFzcz0iYmFja2dyb3VuZCIgZGF0YS1uYW1lPSJFbGxpcHNlIDExNyIgY3g9IjIyIiBjeT0iMjIiIHI9IjIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQwNCA5NDkxLjUyNikiIGZpbGw9IiNmMmY3ZmEiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJTZWFyY2hiYXJDb2xsYXBzZWRfTSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDU2Ljg1MSAyMy44MTgpIj4KICAgICAgPGcgaWQ9Ikdyb3VwXzI3OCIgY2xhc3M9InNlYXJjaCIgZGF0YS1uYW1lPSJHcm91cCAyNzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwIDEwKSI+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfNiIgZGF0YS1uYW1lPSJQYXRoIDYiIGQ9Ik0wLDAsNS40ODcsNS41NDIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4LjI3MyAxOC41NzgpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDJkNTYiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMiIgZGF0YS1uYW1lPSJFbGxpcHNlIDIiIGN4PSIxMC41IiBjeT0iMTAuNSIgcj0iMTAuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4xNDkgMC4xODIpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDJkNTYiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };